var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 14.25L13.75 8.75",
    stroke: "#858585",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70833 9.66667C8.96146 9.66667 9.16667 9.46146 9.16667 9.20833C9.16667 8.9552 8.96146 8.75 8.70833 8.75C8.4552 8.75 8.25 8.9552 8.25 9.20833C8.25 9.46146 8.4552 9.66667 8.70833 9.66667Z",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2904 14.2507C13.5435 14.2507 13.7487 14.0454 13.7487 13.7923C13.7487 13.5392 13.5435 13.334 13.2904 13.334C13.0372 13.334 12.832 13.5392 12.832 13.7923C12.832 14.0454 13.0372 14.2507 13.2904 14.2507Z",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 11.5C2.75 12.5834 2.96339 13.6562 3.37799 14.6571C3.7926 15.6581 4.40029 16.5675 5.16637 17.3336C5.93245 18.0997 6.84193 18.7074 7.84286 19.122C8.8438 19.5366 9.91659 19.75 11 19.75C12.0834 19.75 13.1562 19.5366 14.1571 19.122C15.1581 18.7074 16.0675 18.0997 16.8336 17.3336C17.5997 16.5675 18.2074 15.6581 18.622 14.6571C19.0366 13.6562 19.25 12.5834 19.25 11.5C19.25 10.4166 19.0366 9.3438 18.622 8.34286C18.2074 7.34193 17.5997 6.43245 16.8336 5.66637C16.0675 4.90029 15.1581 4.2926 14.1571 3.87799C13.1562 3.46339 12.0834 3.25 11 3.25C9.91659 3.25 8.8438 3.46339 7.84286 3.87799C6.84193 4.2926 5.93245 4.90029 5.16637 5.66637C4.40029 6.43245 3.7926 7.34193 3.37799 8.34286C2.96339 9.3438 2.75 10.4166 2.75 11.5Z",
    stroke: "#858585",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountIcon);
export default __webpack_public_path__ + "static/media/discount-icon.ed80eb5f3fb3d826ca25be803ffe9697.svg";
export { ForwardRef as ReactComponent };